import request from '@/utils/request';
import store from '@/store';
// 供应商
export function getCardMakeSupplierList(params) {
  return request({
    url: '/cardmake/card/supplier',
    method: 'get',
    params: params
  });
}
// 列表
export function getCardMakeList(params) {
  return request({
    url: '/cardmake/card/list',
    method: 'get',
    params: params
  });
}
// 创建印刷的
export function cardMakeAdd(data) {
  return request({
    url: '/cardmake/card/add-new',
    method: 'post',
    data: data
  });
}
// 编辑印刷的
export function cardMakeUpdate(data) {
  return request({
    url: '/cardmake/card/update-new',
    method: 'post',
    data: data
  });
}
// 批次号下拉
export function getCardMakeBatchList(params) {
  return request({
    url: '/cardmake/card/batch-list',
    method: 'get',
    params: params
  });
}
// 订单下拉下拉
export function getCardMakeOrderList(params) {
  return request({
    url: '/cardmake/card/order-list',
    method: 'get',
    params: params
  });
}
// 客户下拉下拉
export function getCardMakeCustomerList(params) {
  return request({
    url: '/cardmake/card/customer-list',
    method: 'get',
    params: params
  });
}
// 更新制作状态
export function changeCardMakeStatus(data) {
  return request({
    url: '/cardmake/card/up-make-status',
    method: 'post',
    data: data
  });
}
// 更新结算状态
export function changeCardMakeSettlementStatus(data) {
  return request({
    url: '/cardmake/card/up-settlement-status',
    method: 'post',
    data: data
  });
}
// 更新有效无效
export function changeCardMakeUpStatus(data) {
  return request({
    url: '/cardmake/card/up-status',
    method: 'post',
    data: data
  });
}
// 查看编辑接口
export function getMakeUpInfo(data) {
  return request({
    url: '/cardmake/card/info',
    method: 'post',
    data: data
  });
}
export function getFileInfo(params) {
  return request({
    // url: '/package/banner/upload/file-allow-extensions',
    url: '/cardmake/image/upload/file-allow-extensions',
    method: 'get',
    params: params
  });
}
// 上传设计稿
export function upDesignImg(data) {
  return request({
    url: '/cardmake/card/up-design-img',
    method: 'post',
    data: data
  });
}
// 导出
export function exportFileCardMake(params) {
  return request({
    url: '/cardmake/card/export',
    method: 'get',
    params: params
  });
}
// 印刷结算单 数据列表页
export function getSettlementList(params) {
  return request({
    url: '/orders/settlement/list',
    method: 'get',
    params: params
  });
}
//获取印刷记录单列表 创建
export function getSettlementListCreate(data) {
  return request({
    url: '/orders/settlement/card-make-list',
    method: 'post',
    data: data
  });
}
//获取印刷结算单创建
export function createSettlementList(params) {
  return request({
    url: '/orders/settlement/create',
    method: 'get',
    params: params
  });
}
//印刷结算单详情 info
export function getSettlementDetailsInfo(params) {
  return request({
    url: '/orders/settlement/info',
    method: 'get',
    params: params
  });
}
//印刷结算单详情 list
export function getSettlementDetailsList(params) {
  return request({
    url: '/orders/settlement/settlement-card-print-list',
    method: 'get',
    params: params
  });
}
//印刷结算单详情 移除
export function removeSettlementDetails(params) {
  return request({
    url: '/orders/settlement/count-card-make-print',
    method: 'get',
    params: params
  });
}
//印刷结算单详情 作废
export function delSettlementDetails(params) {
  return request({
    url: '/orders/settlement/del',
    method: 'get',
    params: params
  });
}
//印刷结算单详情 保存
export function updateSettlementDetails(params) {
  return request({
    url: '/orders/settlement/update',
    method: 'get',
    params: params
  });
}
// 创建印刷单 关联信息获取
export function getUpdateInfo(data) {
  return request({
    url: '/cardmake/card/update-info',
    method: 'post',
    data: data
  });
}
// 印刷单导出
export function exportSettlement(data) {
  return request({
    url: '/cardmake/card/export-settlement',
    method: 'post',
    data: data
  });
}
//制卡供应商列表
export function getCardSupplierList(params) {
  return request({
    url: '/cardmake/supplier/list',
    method: 'get',
    params: params
  });
}
// 发送邮寄
export function cardMakeSendEmail(params) {
  return request({
    url: '/cardmake/card/send-email',
    method: 'get',
    params: params,
    timeout: 3 * 60 * 1000
  });
}
// 保存供应商手机邮箱
export function cardMakeSendMsg(params) {
  return request({
    url: '/cardmake/supplier/update',
    method: 'get',
    params: params
  });
}
// 印刷单日志
export function cardMakeLogs(params) {
  return request({
    url: '/cardmake/card/logs',
    method: 'get',
    params: params
  });
}
// 获取制卡分公司列表
export function getMakeCardInfoList(params) {
  return request({
    url: '/orders/card-make/branch-office-list',
    method: 'get',
    params: params
  });
}
// 获取印刷城市
export function getMakeCardCityList(params) {
  return request({
    url: '/cardmake/card/city-list',
    method: 'get',
    params: params
  });
}
// 下载设计稿
export function downDesignDraft(data) {
  return request({
    url: '/cardmake/card/down-design-draft',
    method: 'post',
    data: data
  });
}
// 获取印刷单客户列表
export function getMakeCardCustomerList(params) {
  return request({
    url: '/cardmake/card/get-card-make',
    method: 'get',
    params: params
  });
}
// 【印刷单】物料列表
export function getCardMakeMaterialList(params) {
  return request({
    url: '/cardmake/card/material-list',
    method: 'get',
    params: params
  });
}
// 创建印刷单 关联信息获取(新版：客户/设计工单/制卡/印刷 信息聚合)
export function getUpdateInfoNew(data) {
  return request({
    url: '/cardmake/card/update-info-new',
    method: 'post',
    data: data
  });
}